<template>
  <div class="MatchSeting">
    <div class="left">
      <ul>
        <template class="box">
          <li v-for="(item, index) in navList" :key="item.id" @click="changeNav(index)" :class="index == currentNav ? 'active' : $route.query.type == 'add' ? 'noclick' : ''">{{ item }}</li>
        </template>
      </ul>
    </div>
    <div class="right">
      <GameSet v-if="currentNav == 0"></GameSet>
      <AblitySet v-if="currentNav == 1"></AblitySet>
      <AgeSet v-if="currentNav == 2"></AgeSet>
    </div>
  </div>
</template>

<script>
import GameSet from './components/GameSet'
import AblitySet from './components/AblitySet'
import AgeSet from './components/AgeSet'
import $Bus from '@/pages/projectImpl/js/eventBus'
export default {
  name: 'MatchSeting',
  components: { GameSet, AblitySet, AgeSet },
  data() {
    return {
      navList: ['游戏匹配', '能力匹配', '年龄匹配'],
      currentNav: 0,
      isSave: true,
    }
  },
  provide() {
    return {
      setIsSave: (bol) => {
        this.isSave = bol
      },
    }
  },
  mounted() {
    const info = this.$store.getters['content/getTrainGameInfo']()
    $Bus.$emit('pageHeaderTitle', this.$route.query.name + ' 匹配设置')
    const arr = ['首页', '内容中心', { name: '训练游戏管理', path: info.fullPath || '/content/Traingame' }, '训练游戏匹配设置']
    $Bus.$emit('pageHeaderBreadcrumb', arr)
    window.addEventListener('beforeunload', this.beforeUnloadHandler)
  },
  beforeDestroy() {
    $Bus.$emit('pageHeaderTitle', false)
    window.removeEventListener('beforeunload', this.beforeUnloadHandler)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSave) {
      this.$confirm({
        title: '编辑未保存',
        content: '退出后编辑内容不生效，确定退出嘛？',
        onOk: () => next(),
        onCancel: () => next(false),
      })
    } else {
      next() 
    }
  },
  methods: {
    beforeUnloadHandler(event) {
      console.log(this.isSave)
      if (!this.isSave) {
        event.preventDefault()
        event.returnValue = '编辑未保存，你确定要离开此页面吗？'
      }
    },
    setNav(index) {
      if (this.$route.query.type == 'add') {
        if (index == 0) {
          this.currentNav = index
        } else {
          return
        }
      } else {
        this.currentNav = index
      }
    },
    changeNav(index) {
      if (!this.isSave) {
        this.$confirm({
          title: '编辑未保存',
          content: '退出后编辑内容不生效，确定退出嘛？',
          onOk: () => {
            this.setNav(index)
            this.isSave = true
          },
        })
      } else {
        this.setNav(index)
        this.isSave = true
      }
    },
  },
}
</script>

<style scoped lang="less">
.MatchSeting {
  min-height: 400px;
  padding: 5px 0;
  display: flex;
  width: 100%;
  background-color: #fff;
  .left {
    width: 15%;
    border-right: 1px solid #f2f2f2;
    ul {
      width: 100%;
      padding: 0;
      li {
        list-style: none;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active {
        background: rgb(230, 247, 255);
        color: #1890ff;
        border-right: 4px solid #1890ff;
      }
      .noclick {
        cursor: not-allowed;
        background: #f4f4f4;
        opacity: 0.6;
      }
    }
  }
  .right {
    flex: 1;
    padding: 10px 20px;
    margin-bottom: 80px;
    min-height: 50vh;
  }
}
</style>
